<template>
  <BasicModal
    :title="'ステータス選択'"
    :isShowModal="isShowModal"
    :canCansel="false"
    :width="'32%'"
    @cancel="cancel">
    <template>
        <select class="select"
            v-model="tmpStatus"
            style="max-width: 240px; min-width: 240px; margin: 24px;"
            >
            <option v-for="(sts, keySts) in selectData" 
            v-bind:value="sts.pk" 
            :key="keySts + '-col22'">
                {{ sts.name }}
            </option>
        </select>
    </template>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button is-light" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="setStatus(); $emit('cancel', null, false)">
        保存する
      </button>
    </div>
    <slot></slot>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    BasicModal,
  },
  mixins: [
    controlLogMixin
  ],
  props: {
    isShowModal: {
      type: Boolean,
      required: true
    },
    changeRecruitmentFlow: {
      type: Function,
      required: true
    },
    sk: {
      type: Object,
      required: false
    },
    stss: {
      required: false
    },
  },
  computed: {
    selectData () {
      let stgList = []
      for (let sts of this.stss) {
        if (!sts.is_delete_apply){
          stgList.push(sts)
        } 
    } 
    return stgList
    }
  },
  data () {
    return {
      addFile: null,
      tmpStatus:null
    }
  },
  mounted() {
    this.tmpStatus = this.sk.recruitment_flow_status
  },
  methods: {
    setStatus () {
      this.sendControlLog('応募者ステータス変更', 'ステータス選択モーダルにて、「保存する」ボタンをクリックした。')
      this.sk.recruitment_flow_status = this.tmpStatus
      this.changeRecruitmentFlow(this.sk)
    },
    cancel () {
      this.$emit('cancel', null, false)
    },
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  overflow: auto;
  height: 75vh;
}
.desc {
  font-size: smaller;
  color: #666;
  text-align: left;
}
.input-field {
  padding: 8px;
  p {
    font-weight: 600;
    margin-bottom: 4px;
  }
}
.table-box {
  display: block;
  height: 100%;
  width: 100%;
  overflow: auto;
  tr {
    display: table;
    width: 100%;
    td {
      padding: 8px;
      height: auto;
      min-height: 36px;
    }
  }
}
.table-box::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.table-td {
  vertical-align: middle;
  border: solid thin #ccc;
  padding: 2px;
  textarea {
    border: dotted thin #ccc;
    min-height: 36px;
    resize: none;
    background: transparent; border-radius: 0; height: 100%; width: 100%;
  }
}
.table-th {
  padding: 2px 8px;
  text-align: center;
  vertical-align: middle;
  border: solid thin #ccc;
  font-size: 14px;
}
.file-box {
  font-size: smaller;
  overflow: hidden;
  width: 100%;
  height: 24px;
  display: inline-flex;
  margin-bottom: 4px;
  img {
    width: 16px; height: 16px; margin-right: 4px;
  }
  span {
    cursor: pointer; color: red; margin-right: 8px;
  }
  a {
    display: block;
    width: 150px;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Manage/ModalStatus.vue